import type AppState from 'src/types/appState';

export const isAggregatedAd = (
  postChannel: AppState['session']['postChannel'],
) => postChannel === 'IMPORT';
